// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"contacts_wrapper__vwU3Z","info":"contacts_info__v_bth","label":"contacts_label___x_TF","text":"contacts_text__H_GoL","map":"contacts_map__2hZDg"};